import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'

export default class extends Controller {
  static values = { colleaguesBaseUrl: String, shiftIndex: Number, loading: { type: Boolean, default: false } }
  static targets = ['frame', 'loader']

  static debounces = [
    {
      name: 'filterEmployee',
      wait: 450
    }
  ]

  connect() {
    useDebounce(this)

    addEventListener('turbo:before-fetch-request', async (event) => {
      const target_id = event.target.getAttribute('id')

      if(target_id.startsWith('shift-selector')) {
        this.loadingValue = true
      }
    })

    // triggered after sorting header used and result rendered
    this.frameTarget.addEventListener('turbo:frame-render', async (event) => {
      this.loadingValue = false
    })

    addEventListener('turbo:fetch-request-error', ({ _target }) => {
      //console.log('shift-swap--shift-selector | turbo:fetch-request-error')
      this.loadingValue = false
    })
  }

  selectShift(event) {
    this.loadingValue = true

    const custom_event = new CustomEvent('shift-swaps:selected', { detail: event.params } )
    window.dispatchEvent(custom_event)
  }

  // TODO: store location and q_user_name in values ?
  filterDutyId(event) {
    //console.log('shift-swap--shift-selector | locationChanged', event.target.value, 'frame scr', this.element.src)
    this.loadingValue = true

    const url = this.prepareUrl({ duty_id: event.target.value })
    this.renderTurboStreamFromUrl(url, this.frameId(), 'replace')
  }

  filterEmployee(event) {
    this.loadingValue = true

    const url = this.prepareUrl({ q_user_name: event.target.value })
    this.renderTurboStreamFromUrl(url, this.frameId(), 'replace')
  }

  frameId() {
    return `shift-selector-${this.shiftIndexValue}`
  }

  prepareUrl(opts = {}) {
    let url = new URL(this.colleaguesBaseUrlValue)

    Object.entries(opts).forEach((o) => {
      const [key, value] = o
      url.searchParams.set(key, value)
    })

    return url.toString()
  }

  // TODO: refactor, used in a few places
  renderTurboStreamFromUrl(url, target, action = 'replace') {
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(r => r.text())
    .then(html => {
      html = `<turbo-stream action="${action}" target="${target}"><template>${html}</template></turbo-stream>`
      Turbo.renderStreamMessage(html)

      this.loadingValue = false
    })
  }

  loadingValueChanged() {
    if(this.loadingValue) {
      this.loaderTarget.classList.add('loading')
    } else {
      this.loaderTarget.classList.remove('loading')
    }
  }
}
